import { FeatureFlagsReducerState } from './types'

export const initialState: FeatureFlagsReducerState = {}

export const featureFlagsReducer = (
  state = initialState,
  action
): FeatureFlagsReducerState => {
  switch (action.type) {
    default:
      return state
  }
}

export default featureFlagsReducer
